import { QUERY_USER_REPORT_BY_CITY, UPDATE_USER_REPORT } from "@/services/web/api-user-report.const";
import { useTrackedMutation, useTrackedQuery } from "@/hooks/apollo-insights-hooks";

import { GetUserReportByCityIdQueryVariables } from "@/types/gql/graphql";
import { SkipToken, skipToken } from "@apollo/client/react";
import { useMemo } from "react";

export const useQueryListUserReport = (variables: GetUserReportByCityIdQueryVariables | SkipToken) => {
  const options = useMemo(() => {
    if (variables === skipToken) {
      return skipToken;
    }
    return {
      variables,
      actionName: "GetUserReportByCityId",
    };
  }, [variables]);

  const { data, loading } = useTrackedQuery(QUERY_USER_REPORT_BY_CITY, options);

  return {
    data: data?.getUserReportsByCityId ?? { results: [], totalPages: 0 },
    isLoadingUserReports: loading,
  };
};

export const useUpdateUserReport = (variables: GetUserReportByCityIdQueryVariables | SkipToken) => {
  const refetchQueriesConfig = useMemo(() => {
    if (variables === skipToken) {
      return [];
    }
    return {
      refetchQueries: [
        {
          query: QUERY_USER_REPORT_BY_CITY,
          variables,
        },
      ],
      awaitRefetchQueries: true,
    };
  }, [variables]);

  const [updateUserReport] = useTrackedMutation(UPDATE_USER_REPORT, {
    actionName: "UpdateUserReport",
    ...refetchQueriesConfig,
  });

  return {
    updateUserReport,
  };
};
